<template>
  <div class="div-width" :style="'width:'+width" :class="{hidden}">
    <slot></slot>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    width: {
      type: String,
      default: "",
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  created() {},

  methods: {},
}
</script>
<style lang='less' scoped>
.div-width {
  flex-shrink: 0;
}
.hidden {
  overflow: hidden;
}
</style>
